import { Accordion, AccordionTab } from "primereact/accordion";
import { CompanyTable } from "./CompanyTable";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { ConsultantTable } from "./ConsultantTable";
import { FrequencyTable } from "./FrequencyTable";
import { AcknowledgeTable } from "./AcknowledgeTable";

export const TimesheetSetting = () => {
    const toast = useRef<any>(null);
    return (
        <>
            <Accordion>
                <AccordionTab header="Timesheet Email Sending Setting Company Wise">
                    <CompanyTable toast={toast} />
                </AccordionTab>
            </Accordion>
            <Accordion>
                <AccordionTab header="Timesheet Email Sending Setting Consultant Wise">
                    <ConsultantTable toast={toast} />
                </AccordionTab>
            </Accordion>
            <Accordion>
                <AccordionTab header="Timesheet Email Sending Frequency Setting">
                    <FrequencyTable toast={toast} />
                </AccordionTab>
            </Accordion>
            <Accordion>
                <AccordionTab header="Timesheet Email Sending Acknowledge Setting">
                    <AcknowledgeTable toast={toast} />
                </AccordionTab>
            </Accordion>

            <Toast ref={toast} />
        </>
    );
}